import { render } from "./QuebraCabeca1View.vue?vue&type=template&id=1e0d3544&scoped=true"
import script from "./QuebraCabeca1View.vue?vue&type=script&lang=js"
export * from "./QuebraCabeca1View.vue?vue&type=script&lang=js"

import "./QuebraCabeca1View.vue?vue&type=style&index=0&id=1e0d3544&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e0d3544"]])

export default __exports__